import { Module } from "vuex";

import { API_BIS_LISTLAYOUT, API_BIS_CUSTOMFIELD_LIST } from "@/configs/Apis";

import Ajax from "@/utils/DuduAjax";

import { isEmpty, isEmptyOrWhiteSpace } from "@/utils/Common";

declare interface ProjectModule {
  info: any
  metadata: Array<any>
  listLayout: string
}

const baseWidth = 140;

const defaultColumns = [
  { prop: "patentNo", label: "申请号", hidden: false },
  { prop: "patentType", label: "专利类型", hidden: false },
  { prop: "title", label: "专利名称", hidden: false },
  // { prop: "modifiedTime", label: "导入时间", hidden: false },
  { prop: "appDate", label: "申请日", hidden: false },
  { prop: "pubNo", label: "公开(公告)号", hidden: false },
  { prop: "pubDate", label: "公开(公告)日", hidden: false },
  { prop: "authDate", label: "授权日", hidden: false },
  { prop: "country", label: "专利所属国", hidden: false },
  { prop: "patentee", label: "当前专利权人", hidden: false },
  { prop: "applicants", label: "申请人", hidden: false, width: 180 },
  { prop: "primaryApplicantName", label: "主申请人", hidden: false, width: 180 },
  { prop: "applicantCountry", label: "申请人(国家)", hidden: false },
  { prop: "applicantProvince", label: "申请人(省)", hidden: false },
  { prop: "applicantCity", label: "申请人(市)", hidden: false },
  { prop: "applicantArea", label: "申请人(区县)", hidden: false },
  { prop: "applicantAddress", label: "申请人地址", hidden: false },
  { prop: "inventors", label: "发明人", hidden: false },
  { prop: "primaryInventorName", label: "主发明人", hidden: false, width: 180 },
  { prop: "agencyName", label: "代理机构", hidden: false },
  { prop: "agentName", label: "代理人", hidden: false },
  { prop: "priorityPatents", label: "优先权", hidden: false },
  { prop: "inteAppDate", label: "国际申请日", hidden: false },
  { prop: "inteAppNo", label: "国际申请号", hidden: false },
  { prop: "intePubDate", label: "国际公布日", hidden: false },
  { prop: "intePubNo", label: "国际公布号", hidden: false },
  { prop: "legalStatus", label: "法律状态", hidden: false },
  { prop: "primaryIpc", label: "IPC主分类", hidden: false },
  { prop: "miniIpc", label: "IPC小类", hidden: false },
  { prop: "shortIpc", label: "IPC大类", hidden: false },
  { prop: "ipc", label: "IPC", hidden: false },
  { prop: "cpc", label: "CPC", hidden: false },
  { prop: "ecla", label: "ECLA", hidden: false }
];

const module: Module<ProjectModule, any> = {
  namespaced: true,
  state: {
    info: null,
    metadata: [],
    listLayout: ""
  },

  getters: {
    customfields(state) {
      const map: Map<string, number> = new Map([["VARCHAR", 0], ["ENUM", 100], ["TEXT", 200]]);
      return JSON.parse(JSON.stringify(state.metadata)).sort((item1: any, item2: any) => {
        const left = (map.get(item1.fieldType) || 0);
        const right = (map.get(item2.fieldType) || 0);
        let seed1 = 0;
        let seed2 = 0;

        let match = /_(\d+)$/g.exec(item1.fieldName);
        if (match && match.length) {
          seed1 = parseInt(match[1]);
        }

        match = /_(\d+)$/g.exec(item2.fieldName);
        if (match && match.length) {
          seed2 = parseInt(match[1]);
        }
        return (left + seed1) - (right + seed2);
      });
    }
  },

  mutations: {
    info(state, payload) {
      state.info = payload;
    },
    metadata(state, payload) {
      state.metadata = payload;
    },
    listLayout(state, payload) {
      state.listLayout = payload;
    }
  },
  actions: {
    setProjectInfo({ commit, dispatch }, payload) {
      commit("info", payload);
      return dispatch("setCustomField", payload).then(() => dispatch("setListLayout", payload));
    },

    setListLayout({ commit, state }, payload) {
      return Ajax.get<string>(API_BIS_LISTLAYOUT, { listName: "PATENT", projectId: payload.id }).then((layout) => {
        let layoutObj: Array<any>;
        if (isEmptyOrWhiteSpace(layout)) {
          layoutObj = JSON.parse(JSON.stringify(defaultColumns));
        } else {
          layoutObj = JSON.parse(layout || "[]");
        }
        const customfield = state.metadata;
        const customfieldMap = new Map();
        if (customfield && customfield.length) {
          customfield.forEach(field => customfieldMap.set(field.fieldName.replace("_", ""), field));
        }

        layoutObj.forEach((item, index) => {
          // 删除不存在的字段
          if (/^(enum|varchar|text)_?\d+$/g.test(item.prop) && !customfieldMap.has(item.prop)) {
            layoutObj[index] = null;
          }
          // 如果存在从map中删除
          if (customfieldMap.has(item.prop)) {
            item.label = customfieldMap.get(item.prop).label;
            customfieldMap.delete(item.prop);
          }
        });

        customfieldMap.forEach((value, key) => layoutObj.push({ prop: key.replace("_", ""), label: value.label, hidden: true }));
        layoutObj = layoutObj.filter(field => !isEmpty(field));
        layoutObj.forEach(field => {
          if (!field.hasOwnProperty("width")) {
            field.width = baseWidth;
          }
        });
        commit("listLayout", JSON.stringify(layoutObj));
      });
    },

    setCustomField({ commit }, payload) {
      return Ajax.get(API_BIS_CUSTOMFIELD_LIST, { projectId: payload.id }).then((customfield) => commit("metadata", customfield));
    },

    clearProject({ commit }) {
      commit("info", null);
      commit("metadata", []);
      commit("listLayout", "");
    }
  }
};

export default module;
